import React from "react";
import { getString } from "../../utilities";
import HeavenlyBody from "./heavenlyBody";
import routeCodes from "../../config/routeCodes";

export default function PrintablesPlanet() {
  return (
    <HeavenlyBody path={routeCodes.PRINTABLES} styles={["printables-planet"]}>
      <span>{getString("printables.title.0")}</span>
    </HeavenlyBody>
  );
}
